import React from "react";
import { Navigate } from "react-router-dom";
import { Container, Spinner, Alert } from "react-bootstrap";
import { useAuth } from "../../context/AuthContext";

// Route guard for admin-only pages. Uses AuthContext so it does no DB work
// of its own — instant for already-loaded sessions.
const RequireAdmin = ({ children }) => {
  const { user, roles, loading } = useAuth();

  if (loading) {
    return (
      <Container
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "60vh" }}
      >
        <Spinner animation="border" role="status" variant="success" />
      </Container>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!roles.isAdmin) {
    return (
      <Container
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "60vh" }}
      >
        <div style={{ maxWidth: "500px", textAlign: "center" }}>
          <Alert variant="danger">
            <b>You do not have permission to view this page.</b>
            <br />
            This area is restricted to administrators.
          </Alert>
        </div>
      </Container>
    );
  }

  return children;
};

export default RequireAdmin;
